<template>
  <div>
    <p>
      Сиды
      <template v-if="!hasSeeds">
        <br>
        Нет данных
      </template>
    </p>
    <ul v-if="hasSeeds" class="seed-list">
      <li
        v-for="seed in seeds"
        :key="seed"
      >{{seed}}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SeedsView',

  props: {
    seeds: {
      type: Array,
      default: null,
    },
  },

  computed: {
    /** @returns {boolean} */
    hasSeeds() {
      if(this.seeds === null) {
        return false;
      }
      if(this.seeds.length === 0) {
        return false;
      }
      return true;
    },
  },
}
</script>

<style scoped>
ul.seed-list {
  list-style-type: none;
  padding-left: 0;
}
</style>